import { PlusOutlined } from "@ant-design/icons";
import { useQuery } from "@tanstack/react-query";
import { Button, Card, Col, Flex, Row, Spin, Switch } from "antd";
import { useState } from "react";
import { BsPlusSquare } from "react-icons/bs";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";
import DeleteSVG from "../../assets/common/DeleteSVG";
import ClockSVG from "../../assets/teamMember/ClockSVG";
import EditSVG from "../../assets/teamMember/EditSVG";
import { listGiftCard } from "../../network/giftCard";
import { queryKeys } from "../../services/react-query/queryKeys";
import HeadTable from "../GlobalTable/HeadTableD";
import SubInfo from "../admin/common/SubInfo";
import Empty from "../common/Empty";
import AddGiftCardForm from "../giftCard/AddGiftCard";
import DeleteGiftCard from "../giftCard/DeleteService";

const GiftCardTable = () => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [activeModal, setActiveModal] = useState(null);
  const [giftCardData, setGiftCardData] = useState(null);
  const [selectedGiftCardId, setSelectedGiftCardId] = useState(null);
  const openModal = (modal: any) => {
    setActiveModal(modal);
  };
  const openDeleteModal = (modal: any, data: any) => {
    setActiveModal(modal);
    setGiftCardData(data);
  };
  const closeModal = () => {
    setActiveModal(null);
    setGiftCardData(null);
    setSelectedGiftCardId(null);
  };
  const { locationId } = useSelector(
    (state: { calendar: { locationId: number } }) => ({
      locationId: state.calendar.locationId,
    })
  );
  const {
    data: listGiftCards,
    isLoading,
    isError,
  } = useQuery([queryKeys?.listGiftCards], () => listGiftCard(locationId));

  const modalComponents = {
    AddGiftCard: (
      <AddGiftCardForm
        id={selectedGiftCardId ? selectedGiftCardId : undefined}
        visible={true}
        onClose={closeModal}
      />
    ),
    DELETEGiftCard: (
      <DeleteGiftCard
        visible={true}
        onClose={closeModal}
        editGiftCardData={giftCardData}
      />
    ),
  };

  const renderModal = activeModal ? modalComponents[activeModal] : null;
  const intl = useIntl();

  return (
    <div className="tabs p-6 bg-[#eef0ff]">
      {renderModal}
      <HeadTable
        data={listGiftCards?.data}
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        placeHolderSerch={intl.formatMessage({
          id: "gift_card_table_search_placeholder",
        })}
        hideSearch
        hideFilter
        button={
          <Button
            type="primary"
            onClick={() => openModal("AddGiftCard")}
            icon={<BsPlusSquare />}
            className={`${listGiftCards?.data?.length > 0 && "!hidden"}`}
            disabled={listGiftCards?.data && listGiftCards.data.length > 0}
          >
            {intl.formatMessage({ id: "add_gift_card_button_label" })}
          </Button>
        }
      />
      <Spin size="large" spinning={isLoading}>
        {listGiftCards?.data && listGiftCards?.data.length > 0 ? (
          listGiftCards?.data?.map((data: any, index: number) => (
            <Card key={index} className="">
              <Flex justify="flex-end" className="mb-8">
                <div className="flex flex-wrap items-center justify-center gap-4 ">
                  <Col>
                    <Button
                      type="primary"
                      className="btn-primary-edit"
                      onClick={() => {
                        setSelectedGiftCardId(data?.id);
                        openModal("AddGiftCard");
                      }}
                      icon={<EditSVG />}
                    >
                      {intl.formatMessage({
                        id: "edit_gift_cards_button_label",
                      })}
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      type="primary"
                      className="btn-primary-danger"
                      onClick={() => openDeleteModal("DELETEGiftCard", data)}
                      icon={<DeleteSVG />}
                    >
                      {intl.formatMessage({
                        id: "delete_gift_card_button_label",
                      })}
                    </Button>
                  </Col>
                </div>
              </Flex>
              <div>
                <Row
                  justify={"space-between"}
                  className="mt-4 mb-5"
                  gutter={{ xs: 8, sm: 16, md: 8, lg: 14, xl: 10 }}
                  align={"middle"}
                >
                  <Col>
                    <Row
                      justify={"space-between"}
                      gutter={{ xs: 8, sm: 16, md: 8, lg: 14, xl: 10 }}
                      wrap
                      align={"middle"}
                    ></Row>
                  </Col>
                  <Col>
                    <Row
                      justify={"space-between"}
                      gutter={{ xs: 8, sm: 16, md: 8, lg: 14, xl: 10 }}
                    >
                      <Col>
                        <Switch
                          className="custom-switch-text"
                          style={{ border: "none" }}
                          disabled
                          checked={data.available_sale === "in_store_online"}
                          checkedChildren={
                            <span style={{ color: "black" }}>
                              {intl.formatMessage({
                                id: "online_display_label",
                              })}
                            </span>
                          }
                          unCheckedChildren={
                            <span style={{ color: "gray" }}>
                              {intl.formatMessage({
                                id: "online_display_label",
                              })}
                            </span>
                          }
                          defaultChecked
                        />
                      </Col>
                      <Col>
                        <Switch
                          className="custom-switch-text"
                          style={{ border: "none" }}
                          disabled
                          checked={data.allow_custom_gift_card}
                          checkedChildren={
                            <span style={{ color: "black" }}>
                              {intl.formatMessage({
                                id: "custom_value_addition_label",
                              })}
                            </span>
                          }
                          unCheckedChildren={
                            <span style={{ color: "gray" }}>
                              {intl.formatMessage({
                                id: "custom_value_addition_label",
                              })}
                            </span>
                          }
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <label className="mb-2 text-[#020418]">
                  {intl.formatMessage({ id: "gift_card_values_label" })}
                </label>
                <div className="flex flex-wrap gap-2 my-2">
                  {data?.values?.map(
                    (
                      item: { id: number; value: string },
                      valueIndex: number
                    ) => (
                      <div
                        className="m-1 bg-[#EEF0FF]    rounded-md  gap-[8px] flex items-center justify-center mx-2"
                        style={{ minWidth: "140px", height: "50px" }}
                        key={valueIndex}
                      >
                        <SubInfo
                          value={item?.value}
                          label={intl.formatMessage({
                            id: "SARshort",
                          })}
                        />
                      </div>
                    )
                  )}
                </div>
              </div>

              <div className="flex items-center gap-1">
                <span className="translate-y-[3px]">
                  <ClockSVG height={18} width={18} />
                </span>
                <span>
                  {intl.formatMessage({ id: "gift_card_validity_label" })}
                </span>
                <span
                  className="p-1 text-color-primary"
                  style={{
                    boxShadow: "0px 2px 10px 0px rgba(156, 171, 194, 0.10)",
                  }}
                >
                  <p className="capitalize">{data.voucher_duration?.name}</p>
                </span>
              </div>
            </Card>
          ))
        ) : !isLoading ? (
          <Empty
            title={intl.formatMessage({ id: "no_gift_cards" })}
            subTitle={intl.formatMessage({ id: "add_gift_cards_now" })}
            buttons={
              <div>
                <Button
                  onClick={() => openModal("AddGiftCard")}
                  className="border-none bg-[#EEF0FF] shadow-none outline-none text-[#75757E]"
                  icon={<PlusOutlined />}
                >
                  <FormattedMessage id="add_gift_cards" />
                </Button>
              </div>
            }
          />
        ) : (
          <div className="h-[300px]"></div>
        )}
      </Spin>
    </div>
  );
};

export default GiftCardTable;
